// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer-module--footer--1c9am","footer__lastMenu":"Footer-module--footer__last-menu--2g7va","footer__search":"Footer-module--footer__search--WD1M_"};